import { useContext } from 'react'
import { createPortal } from 'react-dom'
import { useHistory } from 'react-router-dom'
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined'
import Tooltip from '../common/Tooltip'
import { DashboardCardFooterContext } from '../dashboard/DashboardCard'
import { client } from '../../hooks/Client'
import deepAnalysisPath from '../../helpers/deepAnalysis/deepAnalysisPath'

/**
 * "Diepte-analyse" action — navigates to the deep-analysis page for an anchor.
 *
 * Inside a dashboard card it portals its icon into the card's bottom bar
 * (same mechanism as DashboardCardOptions); anywhere else it renders inline.
 *
 * @param {object} props
 * @param {'effect' | 'research' | 'activity'} props.type - Anchor type for the route
 * @param {string} props.id - Anchor entity ID
 * @param {import('../../helpers/compareHelpers/periodQuery').CardPeriodValue|null} [props.periodValue] - The card's chosen period; travels along as url query (see docs/features/deep-analysis-period.md)
 * @param {boolean} [props.inline] - Force inline rendering even inside a card
 */
const DeepAnalysisButton = ({ type, id, periodValue = null, inline = false }) => {
    const history = useHistory()
    const footerEl = useContext(DashboardCardFooterContext)

    if (!id) return null

    const icon = (
        <span className='dashboard-card-options-icon'>
            <Tooltip content='Diepte-analyse' top='-35px'>
                <QueryStatsOutlinedIcon
                    onClick={() => history.push(deepAnalysisPath(client, type, id, periodValue))}
                />
            </Tooltip>
        </span>
    )

    if (!inline && footerEl) return createPortal(icon, footerEl)
    return icon
}

export default DeepAnalysisButton
